import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {NgxTextBoxFilter} from "./ngx-text-box-filter";
import {Filter} from "../../ngx-types";

@Component({
  selector: 'app-text-box',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.scss']
})
export class TextBoxComponent extends NgxTextBoxFilter implements OnInit {
  @Input() filter: Filter;
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();
  @Input() label: string;
  @Input() options: any;

  ngOnInit(): void {
  }


}
